import XLSX from 'xlsx';

export default function formatColumnsCurrency(worksheet, numCols) {
  const range = XLSX.utils.decode_range(worksheet['!ref']);
  // note: range.s.r + 1 skips the header row
  // eslint-disable-next-line no-plusplus
  for (let row = range.s.r + 1; row <= range.e.r; row++) {
    numCols.forEach(numCol => {
      const ref = XLSX.utils.encode_cell({ r: row, c: numCol });
      if (worksheet[ref] && worksheet[ref].t === 'n') {
        worksheet[ref].z = '0.00 €';
      }
    });
  }
}
